import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';

/**
 * Guard für alle authentifizierten Bereiche (Customer-Shell + Admin-Shell).
 *
 * Anonyme User landen auf der Login-Seite. Eingeloggte User dürfen passieren;
 * der nachgelagerte `roleGuard` prüft anschließend die rollen-spezifische
 * Erreichbarkeit der konkreten Route.
 *
 * Idiom (Sprint 4 S4-20): Functional-Guard returned `UrlTree`, statt
 * `router.navigate(...)` als Side-Effect zu rufen.
 */
export const dashboardGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.user()?.token) {
    return true;
  }
  // Sprint 9 (ADR-011): Ziel-URL als returnUrl mitgeben, damit der
  // Mail-Link auf `/auftrag/:id` nach dem Login dort landet. Login,
  // Register etc. werden nie als returnUrl gespeichert (Guard greift
  // nur für die geschützten Shells).
  return router.createUrlTree(['/auth/login'], {
    queryParams: { returnUrl: state.url },
  });
};
